import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

/**
 * Re-reads the person's role and permissions when they come back to the tab,
 * so a role the owner changed shows up in the menu without signing out.
 * The auth provider caches the role for a minute at most.
 */
export const useRoleRefresh = () => {
  const queryClient = useQueryClient();
  useEffect(() => {
    const refresh = () => {
      if (document.visibilityState !== "visible") return;
      queryClient.invalidateQueries({ queryKey: ["auth"] });
    };
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, [queryClient]);
};
